import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-sky-50 border-t border-sky-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & tagline */}
          <div>
            <img src="/logo.png" alt="Clarendon Family Medicine" className="h-14 w-auto object-contain mb-3" />
            <p className="text-sky-700 text-sm leading-relaxed max-w-xs">
              Compassionate, full-spectrum family medicine for the entire community of Clarendon and surrounding areas.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-sky-900 uppercase tracking-wide text-xs mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="text-sky-500 mt-0.5 flex-shrink-0" />
                <p className="text-sky-700 text-sm">One Medical Center Drive<br />Clarendon, TX 79226</p>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} className="text-sky-500 flex-shrink-0" />
                <a href="tel:8068743531" className="text-sky-700 text-sm hover:text-sky-600 transition-colors">(806) 874-3531</a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-semibold text-sky-900 uppercase tracking-wide text-xs mb-4">Office Hours</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <Clock size={16} className="text-sky-500 flex-shrink-0" />
                <div>
                  <p className="text-sky-700 text-sm">Mon – Thu: 8:00 AM – 5:00 PM</p>
                  <p className="text-sky-700 text-sm">Friday: 8:00 AM – 12:00 PM</p>
                  <p className="text-sky-500 text-xs mt-1">Closed Sat & Sun</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-sky-200 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sky-500 text-xs">
            &copy; {new Date().getFullYear()} Clarendon Family Medicine. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacypolicy"
              data-testid="footer-privacy-link"
              className="text-sky-600 hover:text-sky-800 text-xs font-medium transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/termsandconditions"
              data-testid="footer-terms-link"
              className="text-sky-600 hover:text-sky-800 text-xs font-medium transition-colors"
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to="/social"
              data-testid="footer-staff-login-link"
              className="text-sky-300 hover:text-sky-500 text-xs transition-colors"
              title="Staff access"
            >
              Staff Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
